import { render, staticRenderFns } from "./ProjectsHeader.vue?vue&type=template&id=3ad162de&"
import script from "./ProjectsHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {LicensesUnavailableModal: require('/lasso/components/modals/LicensesUnavailableModal.vue').default,IconAddPrimary: require('/lasso/components/icons/IconAddPrimary.vue').default,IconSelectPropertyLarge: require('/lasso/components/icons/IconSelectPropertyLarge.vue').default,IconRefresh: require('/lasso/components/icons/IconRefresh.vue').default,IconList: require('/lasso/components/icons/IconList.vue').default,IconEditPrimary: require('/lasso/components/icons/IconEditPrimary.vue').default,IconDetails: require('/lasso/components/icons/IconDetails.vue').default,IconReportPdf: require('/lasso/components/icons/IconReportPdf.vue').default,Template: require('/lasso/components/templates/Template.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ad162de')) {
      api.createRecord('3ad162de', component.options)
    } else {
      api.reload('3ad162de', component.options)
    }
    module.hot.accept("./ProjectsHeader.vue?vue&type=template&id=3ad162de&", function () {
      api.rerender('3ad162de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/projects/ProjectsHeader.vue"
export default component.exports